import React, { ReactElement } from "react";
import {
  AccessAlarm as AccessAlarmIcon,
  Business as BusinessIcon,
  Dashboard as DashboardIcon,
  Group as GroupIcon,
  Rule as RuleIcon,
  StackedLineChart as ChartIcon,
  AlarmOff as TimeOffIcon,
  EventBusy as AbsenceIcon,
  CalendarMonth as CalendarMonthIcon,
  Loop as LoopIcon,
  Celebration as CelebrationIcon,
} from "@mui/icons-material";
import { isTimeOffEnabled } from "../../featureFlags";
import { useUser } from "../../hooks";

type Link = {
  heading: string;
  name: string;
  to: string;
  icon: ReactElement;
};

export const LinksComponent = (): { [key: string]: Link[] } => {
  const user = useUser();
  const isBetaTester = user?.isBeta;

  const isTimeOffBetaEnabled = isTimeOffEnabled && isBetaTester;

  const links: (Link | undefined)[] = [
    {
      heading: "Manage",
      name: "Dashboard",
      to: "",
      icon: <DashboardIcon />,
    },
    {
      heading: "Manage",
      name: "Timesheets",
      to: "timesheets",
      icon: <AccessAlarmIcon />,
    },
    isTimeOffBetaEnabled
      ? {
          heading: "Manage",
          name: "Time off",
          to: "time-off",
          icon: <TimeOffIcon />,
        }
      : undefined,
    isTimeOffBetaEnabled
      ? {
          heading: "Manage",
          name: "Time in lieu",
          to: "time-in-lieu",
          icon: <LoopIcon />,
        }
      : undefined,
    {
      heading: "Admin",
      name: "Dashboard",
      to: "admin",
      icon: <DashboardIcon />,
    },
    {
      heading: "Admin",
      name: "Approvals",
      to: "admin/approvals",
      icon: <RuleIcon />,
    },
    {
      heading: "Admin",
      name: "Clients",
      to: "admin/clients",
      icon: <BusinessIcon />,
    },
    {
      heading: "Admin",
      name: "Employees",
      to: "admin/employees",
      icon: <GroupIcon />,
    },
    {
      heading: "Admin",
      name: "Reports",
      to: "admin/reports",
      icon: <ChartIcon />,
    },
    isTimeOffBetaEnabled
      ? {
          heading: "Admin",
          name: "Absence Tracker",
          to: "admin/absence",
          icon: <AbsenceIcon />,
        }
      : undefined,
    isTimeOffBetaEnabled
      ? {
          heading: "Admin",
          name: "Time in Lieu",
          to: "admin/time-in-lieu",
          icon: <LoopIcon />,
        }
      : undefined,
    isTimeOffBetaEnabled
      ? {
          heading: "Admin",
          name: "Bank Holidays",
          to: "admin/bank-holidays",
          icon: <CelebrationIcon />,
        }
      : undefined,
    isTimeOffBetaEnabled
      ? {
          heading: "Admin",
          name: "Calendar",
          to: "admin/calendar",
          icon: <CalendarMonthIcon />,
        }
      : undefined,
  ];

  return links
    .filter((l) => l !== undefined)
    .reduce(
      (groups, item): { [key: string]: Link[] } =>
        Object.assign(groups, {
          [item.heading]: (groups[item.heading] || []).concat(item),
        }),
      Object.create(null)
    );
};
